import React from 'react';
import MUIAccordionDetails, {
  AccordionDetailsProps as MUIAccordionDetailsProps,
} from '@mui/material/AccordionDetails';

type AccordionDetailsProps = MUIAccordionDetailsProps;

const AccordionDetails: React.FC<AccordionDetailsProps> = ({
  children,
  ...props
}) => <MUIAccordionDetails {...props}>{children}</MUIAccordionDetails>;

export default AccordionDetails;
